import { ArrowRight } from "@mui/icons-material";
import { Button, Checkbox, TableCell, TableRow, Typography } from "@mui/material";
import { format } from "date-fns";
import { Fragment, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { leadingZerosDateFormat } from "../../../../common/helpers/formatDateTime";
import {
  KtaRow,
} from "../../types/common";
import { MassUpdateStatusRowId } from "../../types/queries";
import {
  ktaRowChangedValue,
  renderRowStatus,
  uiRowKtaToId,
} from "../helpers";
import SalaryTableCells from "./SalaryTableCells";

type Props = {
    row: KtaRow;
    index: number;
    uniqueKtaDates: string[];
    isSelected?: boolean;
    onSelect?: () => void;
  toggleUnclear: (rowId: MassUpdateStatusRowId) => void;
};

const BulkSalaryIncreaseKtaRow = ({
                                    row,
                                    index,
                                    uniqueKtaDates,
                                    isSelected,
                                    onSelect,
                                    toggleUnclear,
                                  }: Props) => {
    const [dirty, setDirty] = useState(false);

    const mainRowBackground = index % 2 === 0 ? "#fff" : "#FAFAFB";
    //
    const raiseDateSalaryKeys = uniqueKtaDates;

    const ktaChangedValue = useMemo(() => {
        const chval = ktaRowChangedValue(row);
        setDirty(chval);
        return chval;
    }, [row]);
    // console.log("changed", ktaChangedValue)

  // FIXME: should this be used?
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setRowClearance = (row: KtaRow) => {
    // console.log(`row ${uiRowKtaToId(row)} is now unclear ${row.unclear}`)
    toggleUnclear(uiRowKtaToId(row));
  }

    return (
        <Fragment key={row.id}>
            <TableRow
                sx={{
                    "& > *": {borderBottom: "unset"},
                    backgroundColor: mainRowBackground,
                }}
            >
                <TableCell>
                    <Checkbox checked={isSelected} onChange={onSelect} disabled={!dirty}/>
                </TableCell>
                {/* <TableCell>
          tbd
          {<IconButton
            sx={{
              visibility: !isEmpty(row.afterRaiseSalaryPerDate)
                ? "visible"
                : "hidden",
            }}
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton> }
        </TableCell> */}
                <TableCell>
                    <Button
                        // disabled={disabled}
                        component={Link}
                        target="_blank"
                        to={`/home/talents/${row.talentId}/employment/${row.employmentId}`}
                        style={{paddingLeft: "0px", paddingRight: "0px"}}
                        // onClick={() => {
                        //   dispatch(setContinousEmploymentId(continuousEmploymentId || ""));
                        // }}
                        endIcon={
                            <ArrowRight
                                sx={{
                                    height: "16px",
                                    width: "16px",
                                    color: (theme) =>
                                        // disabled ? "text.disabled" :
                                        theme.palette.primary.main,
                                }}
                            />
                        }
                    >
                        <Typography variant="header" fontWeight="500" fontSize="12px">
                            {/* {t("talentProfile:employmentAdditionalInfo")} */}
                            {`${row.firstName} ${row.lastName}`}
                        </Typography>
                    </Button>
                </TableCell>
                <TableCell>
                    Employment: {row?.startDate ? format(new Date(row?.startDate as string), leadingZerosDateFormat) : "???"}
                    &nbsp;-&nbsp;{row?.endDate ? format(new Date(row?.endDate as string), leadingZerosDateFormat) : "Ongoing"}
                    &nbsp; -&nbsp;kta&nbsp;date:&nbsp;
                    {format(new Date(row?.raiseDateKta?.date as string), leadingZerosDateFormat)}
                </TableCell>
                {/* <TableCell>{row.raiseDateContEmpExists ? "On" : "Ei"}</TableCell> */}
                <TableCell>{row.employerName}</TableCell>
                <SalaryTableCells
                    row={row}
                    index={index}
                    salaryKeys={raiseDateSalaryKeys}
                    onChange={() => setDirty(ktaRowChangedValue(row))}
                />
                <TableCell>{renderRowStatus(row.status)}</TableCell>
                {/*<Tooltip*/}
                {/*  title={row.unclear ? "This row is marked as unclear" : "This row is marked as clear"}>*/}
                {/*  <Checkbox*/}
                {/*    checked={row.unclear}*/}
                {/*    onChange={() => setRowClearance(row)}*/}
                {/*    disabled={row.status === SalaryIncreaseStatus.SUCCESS}*/}
                {/*  />*/}
                {/*</Tooltip>*/}
                <TableCell>{row.hrRepresentative?.name ?? null}</TableCell>
            </TableRow>
            {/* <BulkSalaryIncreaseCollapsedRows
        open={open}
        row={row}
        afterRaiseDateSalaryPerDateKeys={afterRaiseDateSalaryPerDateKeys}
      /> */}
        </Fragment>
    );
};

export default BulkSalaryIncreaseKtaRow;
